import GradientOverlay from './GradientOverlay';

export default GradientOverlay;
